import React from 'react';
import cn from 'classnames';
import { BodyText } from "../../../../Typography";
import "./BaseInputBodyText.css";
var styles = { "helperText": "cd0a87", "helperText_invalid": "d8c08b" };
const BaseInputBodyText = ({ isInvalid, id, children }) => {
    return (React.createElement(BodyText, { Tag: "p", role: "alert", id: id, className: cn(styles.helperText, isInvalid && styles.helperText_invalid) }, children));
};
export default BaseInputBodyText;
//# sourceMappingURL=BaseInputBodyText.js.map